import { render, staticRenderFns } from "./NotificationActions.vue?vue&type=template&id=2c8d8297&scoped=true"
import script from "./NotificationActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationActions.vue?vue&type=style&index=0&id=2c8d8297&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d8297",
  null
  
)

export default component.exports